<template>
  <article class="member pv3 flex justify-between items-center">
    <user :user="member.user" show-name size="small" is-link></user>
    <div class="flex items-center">
      <b-tag v-if="memberIsTeamOwner" type="is-warning" class="ml2"
        >Owner</b-tag
      >
      <b-tag
        v-if="isTeamOwner && !memberIsTeamOwner"
        :type="tagType"
        size="is-small"
        class="ml2 ttc"
        >{{ member.status }}</b-tag
      >

      <b-dropdown
        v-if="isTeamOwner && !memberIsTeamOwner"
        animation="pop"
        position="is-bottom-left"
        class="ml3"
      >
        <b-button slot="trigger" size="is-small" type="is-text">
          <nice-icon type="far" icon="chevron-down">#</nice-icon>
        </b-button>

        <b-dropdown-item
          v-if="!memberIsSelf && isTeamOwner && member.status === 'accepted'"
          @click="makeOwner"
          class="has-equal-padding-right"
        >
          <nice-icon icon="user" spacing-right></nice-icon>
          <span>Make owner</span>
        </b-dropdown-item>
        <b-dropdown-item
          v-if="!memberIsSelf && isTeamOwner"
          @click="removeMember"
          class="has-equal-padding-right"
        >
          <nice-icon icon="times" spacing-right></nice-icon>
          <span>Remove</span>
        </b-dropdown-item>
      </b-dropdown>
    </div>
  </article>
</template>

<script>
export default {
  props: {
    member: {
      type: Object,
      required: true
    }
  },

  computed: {
    name() {
      const user = this.member.user;
      return user.identity || user.email || user.username;
    },

    memberIsSelf() {
      return this.member.user.id === this.$user.id;
    },
    memberIsTeamOwner() {
      return this.member.user.id === this.currentTeam.owner_id;
    },

    currentTeam() {
      return this.$store.getters["team/current"];
    },

    tagType() {
      switch (this.member.status) {
        case "pending":
          return "is-warning";
        case "accepted":
          return "is-success";
        case "rejected":
          return "is-danger";
      }
    }
  },

  methods: {
    removeMember() {
      this.$buefy.dialog.confirm({
        title: "Remove member",
        message: `Are you sure you want to remove <span class="i">${this.member.user.username}</span> from <span class="i">${this.currentTeam.name}</span>?`,
        hasIcon: true,
        type: "is-danger",
        animation: "pop-modal",
        onConfirm: () => {
          this.$store.dispatch("team/removeMember", { member: this.member });
        }
      });
    },
    makeOwner() {
      // this.$buefy.dialog.confirm({
      //   message: `Are you sure you want to leave ${this.currentTeam.name}`,
      //   onConfirm: () => {
      //     this.$store.dispatch('team/leaveTeam', { member: this.member })
      //   }
      // })
      this.$buefy.toast.open({
        message: `Feature coming soon...`
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.member {
  border-bottom: 1px solid $light_05;
}
</style>
